import { InjectionToken } from '@angular/core';

export const APP_CONFIG: InjectionToken<any> = new InjectionToken<any>('Application Configuration');
